<div
  id="lead-source-modal"
  role="dialog"
  aria-labelledby="leadSourceModalLabel"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="leadSourceModalLabel">
          {{ (isNew ? 'kanban.lossReasonFormModal.titleAdd' : 'kanban.lossReasonFormModal.titleEdit') | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.lossReasonFormModal.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.lossReasonFormModal.namePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.lossReasonFormModal.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'kanban.lossReasonFormModal.description' | translate }}</label>
              <textarea
                class="form-control"
                formControlName="description"
                [placeholder]="'kanban.lossReasonFormModal.descriptionPlaceholder' | translate"
                rows="4"
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'kanban.lossReasonFormModal.cancel' | translate }}
        </button>
        <button
          class="btn btn-primary"
          (click)="save()"
          [disabled]="loading || formGroup.invalid"
        >
          @if (loading) {
          <mat-spinner [diameter]="25" mode="indeterminate" class="px-3" />
          } @else {
          {{ (isNew ? 'kanban.lossReasonFormModal.save' : 'kanban.lossReasonFormModal.update') | translate }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
